import React from "react";
import { ModuleSlider } from '../../common/map';
import { DataProvider, useDataContext } from './context/DataContext';
import Confronto from './components/Confronto/Confronto';
import './styles/index.css';
import './SimfixPage.css';

function SimfixError() {
  const { error, dataLoaded, isLoading, refreshData } = useDataContext();
  if (!error || dataLoaded || isLoading) return null;
  return (
    <div className="simfix-error" role="alert">
      <span>Impossibile caricare i dati della simulazione.</span>
      <button type="button" onClick={refreshData}>Riprova</button>
    </div>
  );
}

function SimFix() {
  return (
    <DataProvider>
      <div className="simfix-page">
        <div className="simfix-module">
          <Confronto />
          <SimfixError />
        </div>

        <ModuleSlider
          showNavbarControls={false}
          setShowNavbarControls={() => {}}
          showSimfixAreas={false}
          setShowSimfixAreas={() => {}}
          showPredictMode={false}
          setShowPredictMode={() => {}}
          showTlGreenWave={false}
          setShowTlGreenWave={() => {}}
          showAssignx={false}
          setShowAssignx={() => {}}
        />
      </div>
    </DataProvider>
  );
}

export default SimFix;
